/*
 * custom-pdp-tabs-relocate.js
 * Standard PDP buy-box redesign (Change #4).
 *
 * Moves the standalone "⚡️ Tabs Section" (ed_tabs) DOM node into the product
 * info column, directly after the purchase form, so the Description / What Room? /
 * Technical / Reviews details sit under the Add-to-Cart button in the right column.
 *
 * Once inside the narrower column the tab labels overflow their container, which is
 * exactly what ed_tabs' own script watches for (scrollWidth > offsetWidth, plus a
 * ResizeObserver) — so it self-switches to accordion mode. We only move the node;
 * we never touch the tabs' internals.
 *
 * Loaded from sections/product__main.liquid, so it only runs on the product template.
 * No-op if either element is missing (e.g. a product with no tabs section).
 */
(function () {
  function relocateTabs() {
    var node = document.querySelector('.ed_tabs-section');
    var info = document.querySelector('.product__information');
    if (!node || !info) return;

    // Move ONLY the inner .ed_tabs-section node — never its parent .shopify-section
    // wrapper. Relocating a whole section wrapper into another section's DOM nests a
    // <div class="shopify-section"> inside another one, which the theme editor reads
    // back as corrupted HTML and reports as "Broken HTML ... in sections/product__main".
    // The ed_tabs script finds its own section by id (#ed_section-{id}) globally, so it
    // keeps working wherever the node lives; the now-empty wrapper stays put at the bottom.

    // Idempotent: bail if it's already the last child of the info column.
    if (node.parentElement === info && node === info.lastElementChild) return;

    info.appendChild(node);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', relocateTabs);
  } else {
    relocateTabs();
  }

  // Theme editor: re-run after a section reload so editing the tabs doesn't snap them
  // back to the bottom of the page until the next full refresh.
  document.addEventListener('shopify:section:load', relocateTabs);
})();
